import MarkerClusterer from '@google/markerclustererplus/dist/markerclustererplus.umd';
import SlimSelect from 'slim-select';

class StoreFinderMap {
    constructor (element, options) {
        this.map = {};
        this.geocoder = {};
        this.mapContainer = element;

        const settings = {
            center: null,
            centerLat: null,
            centerLng: null,
            zoom: 6,
            scrollSpeed: 750,
            minZoom: 5,
            maxZoom: 16,
            clusterMaxZoom: 16,
            resetZoom: 5,
            zoomIn: 20,
            zoomOut: 5,
            panControl: false,
            zoomControl: true,
            scrollwheel: false,
            draggable: true,
            clustering: true,
            overviewMapControl: false,
            rotateControl: false,
            autocomplete: [],
            autocompleteInput: [],
            autocompleteLastKey: null,
            autocompleteBoundsMarker: null,
            places: null,
            country: 'Deutschland',
            geolocation: null,
            setAlternativeGeolocation: true,
            disableDoubleClickZoom: false,
            gestureHandling: 'greedy',
            disableDefaultUI: true,
            mapTypeId: google.maps.MapTypeId.ROADMAP, // eslint-disable-line no-undef
            zoomControlOptions: {
                position: google.maps.ControlPosition.LEFT_TOP // eslint-disable-line no-undef
            }
        };

        this.settings = Object.assign({}, settings, options);

        if (this.settings.centerLat !== null && this.settings.centerLng !== null) {
            this.settings.center = new google.maps.LatLng(this.settings.centerLat, this.settings.centerLng); // eslint-disable-line no-undef
        }

        this.markerImages = [];
        this.mapMarker = [];
        this.locations = marker; // eslint-disable-line no-undef
        this.$mapContainer = document.querySelector('[data-store-finder="mapcontainer"]');
        this.$dealerResult = document.querySelector('[data-store-finder="results"]');
        this.circle = null;
        this.$locationInput = document.querySelector('[data-input-fill-check]');
        this.$formSubmit = document.querySelector('[data-form-submit]');
        this.$form = document.querySelector('[data-form="result"]');

        this.$noBounds = document.querySelector('[data-no-bounds]');
        this.$inputLAT = document.querySelector('[data-location="lat"]');
        this.$inputLNG = document.querySelector('[data-location="lng"]');
        this.$radius = document.querySelector('[data-select="single"][id="radius"]');
        this.radiusSelect = null;

        this.scrollPosition = 0;

        this.markerCluster = [];
        this.activeInfoBoxMarker = null;
        this.selectedProducts = 0;
        this.$selectedProducts = document.querySelector('[data-store-finder-selected]');

        if (document.documentElement.classList.contains('no-csshover')) {
            this.settings.zoom = 5;
        }

        if (document.documentElement.classList.contains('safari')) {
            this.settings.scrollSpeed = 0;
        }

        if (this.mapContainer) {
            this.icons = [{
                url: this.mapContainer.getAttribute('data-mapicon-default'),
                size: [30, 40],
                origin: [0, 0],
                anchor: [(30 / 2), [40]]
            }, {
                url: this.mapContainer.getAttribute('data-mapicon-default-active'),
                size: [30, 40],
                origin: [0, 0],
                anchor: [(30 / 2), [40]]
            }, {
                url: this.mapContainer.getAttribute('data-mapicon-cluster'),
                size: [30, 40],
                origin: [0, 0],
                anchor: [(30 / 2), [40]]
            }, {
                url: this.mapContainer.getAttribute('data-mapicon-bronze'),
                size: [30, 40],
                origin: [0, 0],
                anchor: [(30 / 2), [40]]
            }, {
                url: this.mapContainer.getAttribute('data-mapicon-bronze-active'),
                size: [30, 40],
                origin: [0, 0],
                anchor: [(30 / 2), [40]]
            }, {
                url: this.mapContainer.getAttribute('data-mapicon-silver'),
                size: [30, 40],
                origin: [0, 0],
                anchor: [(30 / 2), [40]]
            }, {
                url: this.mapContainer.getAttribute('data-mapicon-silver-active'),
                size: [30, 40],
                origin: [0, 0],
                anchor: [(30 / 2), [40]]
            }, {
                url: this.mapContainer.getAttribute('data-mapicon-gold'),
                size: [30, 40],
                origin: [0, 0],
                anchor: [(30 / 2), [40]]
            }, {
                url: this.mapContainer.getAttribute('data-mapicon-gold-active'),
                size: [30, 40],
                origin: [0, 0],
                anchor: [(30 / 2), [40]]
            }, {
                url: this.mapContainer.getAttribute('data-mapicon-platinum'),
                size: [30, 40],
                origin: [0, 0],
                anchor: [(30 / 2), [40]]
            }];
        }

        this.initialize();
    }

    initialize () {
        // INIT MAP
        this.map = new google.maps.Map(this.mapContainer, this.settings); // eslint-disable-line no-undef
        this.geocoder = new google.maps.Geocoder; // eslint-disable-line

        // Set Marker Images
        this.setMarkerImages();

        // ADD MARKERS
        if (this.locations !== null) {
            if (this.locations.length > 0) {
                for (let locationIndex = 0; locationIndex < this.locations.length; locationIndex++) {
                    this.addMarker(this.locations[locationIndex]);
                }
            }
        } else {
            console.warn('NO Job-Location where found!!');
        }

        // Center Map with given Coordinates
        this.checkAndSetCenter();

        // Set Cluster for nearby Markers
        this.setCluster(this.markerImages[2].url);

        // Set Radius Select
        this.setSelect();

        // Events
        this.setEvents();
    }

    checkAndSetCenter () {
        let center = null;
        const zoom = this.getZoomByMeters(this.$radius.value * 1000);
        if (this.$inputLNG.value !== '' && this.$inputLAT.value !== '') {
            center = new google.maps.LatLng(this.$inputLAT.value, this.$inputLNG.value); // eslint-disable-line
        } else {
            if (this.settings.center !== null) {
                center = this.settings.center;
            }
        }

        if (center) {
            this.map.setCenter(center);
            this.map.setZoom(Math.floor(zoom) - 1);
        }
    }

    setSelect () {
        if (this.$radius) {
            this.radiusSelect = new SlimSelect({
                select: this.$radius,
                settings: {
                    showSearch: false
                }
            });
        }
    }

    setMarkerImages () {
        for (let iconIndex = 0; iconIndex < this.icons.length; iconIndex++) {
            this.markerImages[iconIndex] = {
                url: this.icons[iconIndex].url,
                anchor: new google.maps.Point(parseInt(this.icons[iconIndex].anchor[0]), parseInt(this.icons[iconIndex].anchor[1])), // eslint-disable-line no-undef
                size: new google.maps.Size(parseInt(this.icons[iconIndex].size[0]), parseInt(this.icons[iconIndex].size[1])), // eslint-disable-line no-undef
                origin: new google.maps.Point(parseInt(this.icons[iconIndex].origin[0]), parseInt(this.icons[iconIndex].origin[1])), // eslint-disable-line no-undef
                scaledSize: new google.maps.Size(parseInt(this.icons[iconIndex].size[0]), parseInt(this.icons[iconIndex].size[1])) // eslint-disable-line no-undef
                // optimized: false
            };
        }
    }

    removeVisualRadius () {
        if (this.circle !== null) {
            this.circle.setMap(null); // eslint-disable-line
            this.circle = null;
        }
    }

    setVisualRadius (lat, lng, radius) {
        this.removeVisualRadius();

        this.circle = new google.maps.Circle({ // eslint-disable-line
            strokeColor: '#1371B3',
            strokeOpacity: 0.3,
            strokeWeight: 0,
            fillColor: '#FFF7EE',
            fillOpacity: 0.4,
            map: this.map,
            center: {
                lat: parseFloat(lat),
                lng: parseFloat(lng)
            },
            radius: radius * 1000
        });
    }

    selectMapMarkerIcon (status, active) {
        let icon = null;

        if (active) {
            icon = this.markerImages[1];
        } else {
            icon = this.markerImages[0];
        }
        return icon;
    }

    addMarker (value) {
        this.$selectedProducts = document.querySelector('[data-store-finder-selected]');
        if (this.$selectedProducts) {
            this.selectedProducts = parseInt(this.$selectedProducts.getAttribute('data-store-finder-selected'));
        }
        for (const [key, data] of Object.entries(value)) { // eslint-disable-line
            const currentMarker = new google.maps.Marker({ // eslint-disable-line no-undef
                position: new google.maps.LatLng(data.position.lat, data.position.lng), // eslint-disable-line no-undef
                id: data.id,
                handelspartnerId: data.handelspartnerId,
                lat: data.position.lat,
                lng: data.position.lng,
                map: this.map,
                icon: this.selectMapMarkerIcon('default', false),
                active: false,
                productsCount: data.foundProductsCount,
                showProductsCount: data.showProductsCount,
                infobox: null
            });

            const infoboxOptions = {
                content: null,
                disableAutoPan: true,
                maxWidth: 0,
                pixelOffset: new google.maps.Size(-280, -60),  //  eslint-disable-line
                zIndex: null,
                //  closeBoxMargin: '10px 2px 2px 2px',
                closeBoxURL: '',
                infoBoxClearance: new google.maps.Size(1, 1),  //  eslint-disable-line
                isHidden: false,
                pane: 'floatPane',
                enableEventPropagation: false
            };

            const infoBoxContent = this.createInfoBox(data);
            infoboxOptions.content = infoBoxContent;

            /*************************************************/

            import('google-maps-infobox').then((InfoBox) => {
                currentMarker.infobox = new InfoBox.InfoBox(infoboxOptions);
            });

            this.mapMarker.push(currentMarker);
            currentMarker.setMap(this.map);

            currentMarker.addListener('click', () => {
                if (currentMarker === this.activeInfoBoxMarker) {
                    this.activeInfoBoxMarker.infobox.close();
                    this.activeInfoBoxMarker = null;
                } else {
                    if (this.activeInfoBoxMarker !== null) {
                        this.activeInfoBoxMarker.infobox.close();
                        this.activeInfoBoxMarker = null;
                    }
                    currentMarker.infobox.open(this.map, currentMarker);
                    this.activeInfoBoxMarker = currentMarker;
                }
                this.setActiveMarker(currentMarker, false);

                this.map.panTo(new google.maps.LatLng(data.position.lat, data.position.lng)); //  eslint-disable-line
                this.map.panBy(-150, 100);
            });

            const $viewProducts = infoBoxContent.querySelector('[data-store-finder-view-products]');
            if ($viewProducts) {
                $viewProducts.addEventListener('click', () => {
                    const storeProducts = new CustomEvent('store_products', {
                        view: window,
                        bubbles: true,
                        cancelable: false,
                        detail: {
                            id: currentMarker.id,
                            handelspartnerId: currentMarker.handelspartnerId
                        }
                    });
                    window.dispatchEvent(storeProducts);
                });
            }

            infoBoxContent.querySelector('.gmap__overlay__close').addEventListener('click', (e) => {
                this.activeInfoBoxMarker.infobox.close();
                this.activeInfoBoxMarker = null;
                this.setActiveMarker(currentMarker, false);
                e.preventDefault();
            });
        }
    }

    createInfoBox (data) {
        let content = '';

        content = '<div class="gmap__overlay"><div class="gmap__overlay__container"><a class="gmap__overlay__close icon-close"><i></i></a>';
        if (typeof data.name !== 'undefined') {
            content += '<p class="store-location__store-name">' + data.name + '</p>';
        }

        if (typeof data.address !== 'undefined') {
            let border = '';
            if (!data.showProductsCount) {
                border = ' has--no-border';
            }

            content += '<p class="store-location__store-km' + border + '">';
            if (typeof data.distanceKm !== 'undefined') {
                content += data.distanceKm + 'km ';
            }
            content += '<a href="https://www.google.com/maps/search/?api=1&query=' + data.position.lat + '%2C' + data.position.lng + '" target="_blank" class="textlink reverse-icon-chevron">' + translations.route + '</a></p>'; // eslint-disable-line
        }

        if (data.showProductsCount) {
            if (this.selectedProducts > 1) {
                content += '<div class="store-finder__store-products"><p class="store-finder__store-products-counter">' + data.foundProductsCount;
                if (data.foundProductsCount === 1) {
                    content += ' ' + translations.product; // eslint-disable-line
                } else {
                    content += ' ' + translations.products; // eslint-disable-line
                }
                content += ' ' + translations.found + '</p>'; // eslint-disable-line
            }

            content += '<button class="button" data-store-finder-view-products>' + translations.productsView + '</button>'; // eslint-disable-line
        }

        content += '</div></div>';

        const boxText = document.createElement('div');
        boxText.innerHTML = content;

        return boxText;
    }

    setActiveMarkerWithId (id) {
        const $mapTab = document.getElementById('storefinder-map');
        if ($mapTab) {
            $mapTab.checked = true;
        }

        this.mapMarker.forEach((marker) => {
            if (parseInt(marker.id) === id) {
                if (marker.active) {
                    this.activeInfoBoxMarker.infobox.close();
                    this.activeInfoBoxMarker = null;
                } else {
                    if (this.activeInfoBoxMarker !== null) {
                        this.activeInfoBoxMarker.infobox.close();
                        this.activeInfoBoxMarker = null;
                    }
                    marker.infobox.open(this.map, marker);
                    this.activeInfoBoxMarker = marker;
                }
                this.setActiveMarker(marker, true);
                this.map.panTo(new google.maps.LatLng(marker.lat, marker.lng)); //  eslint-disable-line
                this.map.panBy(-150, 100);
            }
        });
    }

    setActiveMarker (currentMarker, centerMarker) {
        if (currentMarker.active === false) {
            this.changeMarker('on', currentMarker.id);
            this.setStoreList(currentMarker, 'on');
            if (centerMarker) {
                this.map.panTo(new google.maps.LatLng(currentMarker.lat, currentMarker.lng)); // eslint-disable-line
                this.map.setZoom(12);
            }
        } else {
            this.changeMarker('off');
            this.setStoreList(currentMarker, 'off');
        }
    }

    changeMarker (status, id) {
        if (id) {
            for (let locationsIndex = 0; locationsIndex < this.mapMarker.length; locationsIndex++) {
                if (this.mapMarker[locationsIndex].id === id) {
                    if (status === 'on') {
                        this.mapMarker[locationsIndex].setIcon(this.selectMapMarkerIcon('default', true));
                        this.mapMarker[locationsIndex].active = true;
                    } else {
                        this.mapMarker[locationsIndex].setIcon(this.selectMapMarkerIcon('default', false));
                        this.mapMarker[locationsIndex].active = false;
                    }
                } else {
                    this.mapMarker[locationsIndex].setIcon(this.selectMapMarkerIcon('default', false));
                    this.mapMarker[locationsIndex].active = false;
                }
            }
        } else {
            if (status === 'off') {
                for (let markerIndex = 0; markerIndex < this.mapMarker.length; markerIndex++) {
                    this.changeMarker('off', this.mapMarker[markerIndex].id);
                }
            }
        }
    }

    setCluster (icon) {
        this.markerCluster = new MarkerClusterer(this.map, this.mapMarker, {
            gridSize: 60,
            maxZoom: this.settings.clusterMaxZoom,
            minimumClusterSize: 2,
            zoomOnClick: false,
            averageCenter: true,
            styles: [{
                url: icon,
                width: 30,
                height: 40,
                textLineHeight: 34,
                textColor: '#ffffff',
                fontWeight: 700,
                textSize: 12
            }]
        });

        setTimeout(() => {
            this.markerCluster.addListener('click', (cluster) => {
                const markers = cluster.getMarkers();
                this.map.fitBounds(cluster.bounds_);
                this.changeMarker('off');
                this.setBounds(markers);
            });
        }, 1000);
    }

    setEvents () {
        // this.map.addListener('click', () => {
        // this.setStoreList(null, 'off');
        // this.changeMarker('off');
        // });

        // window.addEventListener('resize', () => this.map.getViewPort().resize()); // eslint-disable-line
    }

    setStoreList (marker, status) {
        const removeContent = (slide) => {
            const $products = slide.querySelector('[data-store-finder-products-container]');
            if ($products.children.length > 0) {
                $products.style.height = '';
                $products.classList.add('is--hidden');
                window.storeSlider.update();

                setTimeout(() => {
                    $products.innerHTML = '';
                    window.storeSlider.update();
                }, 750);
            } else {
                $products.innerHTML = '';
            }
        };

        window.storeSlider.slides.forEach((slide, index) => {
            if (status === 'on') {
                if (parseInt(slide.getAttribute('data-store-id')) === parseInt(marker.id)) {
                    window.storeSlider.slideTo(index);
                    slide.classList.add('is--active');
                } else {
                    slide.classList.remove('is--active');
                    removeContent(slide);
                }
            } else {
                slide.classList.remove('is--active');
                removeContent(slide);
            }
        });
    }

    getZoomByMeters (meters) {
        let mapWidth = 0;
        const pixelRatio = window.devicePixelRatio;

        if (this.$mapContainer.offsetHeight <= this.$mapContainer.offsetWidth) {
            mapWidth = (this.$mapContainer.offsetHeight / pixelRatio);
        } else {
            mapWidth = (this.$mapContainer.offsetWidth / pixelRatio);
        }

        const lat = this.$inputLAT.value;
        const latitudinalAdjustment = Math.cos(Math.PI * lat / 180.0);
        const arg = 40075004 * mapWidth * latitudinalAdjustment / (meters * 256.0);

        return (Math.log(arg) / Math.log(2.0));
    }

    geocodeLatLng () {
        const newCoordinates = new google.maps.LatLng(this.map.getCenter().lat(), this.map.getCenter().lng()); // eslint-disable-line
        this.$inputLAT.value = this.map.getCenter().lat();
        this.$inputLNG.value = this.map.getCenter().lng();

        const bounds = this.map.getBounds();

        const rad = (x) => {
            return x * Math.PI / 180;
        };

        const getDistance = (p1, p2) => {
            const R = 6378137; // Earth’s mean radius in meter
            const dLat = rad(p2.lat() - p1.lat());
            const dLong = rad(p2.lng() - p1.lng());
            const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                Math.cos(rad(p1.lat())) * Math.cos(rad(p2.lat())) *
                Math.sin(dLong / 2) * Math.sin(dLong / 2);
            const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            const d = R * c;
            let km = Math.ceil((d / 1000) * 0.9);

            if (km < 1) {
                km = 1;
            }

            return km; // returns the distance in km
        };

        this.geocoder.geocode({ location: newCoordinates }, (results, status) => {
            if (status === 'OK') {
                if (results[0]) {
                    let found = false;

                    for (let addressIndex = 0; addressIndex < results[0].address_components.length; addressIndex++) {
                        for (let typeIndex = 0; typeIndex < results[0].address_components[addressIndex].types.length; typeIndex++) {
                            if (results[0].address_components[addressIndex].types[typeIndex] === 'postal_code') {
                                if (found === false) {
                                    found = results[0].address_components[addressIndex].short_name;
                                }
                            }
                        }
                    }
                    if (found !== false) {
                        this.$locationInput.value = found;
                        this.$locationInput.focus();

                        setTimeout(() => {
                            const radiusKM = getDistance(this.map.getCenter(), bounds.getNorthEast());
                            const $dealerSearchRange = document.querySelector('[data-select][id="range"]');

                            const oldRange = $dealerSearchRange.options[$dealerSearchRange.selectedIndex].value;
                            const oldText = $dealerSearchRange.options[$dealerSearchRange.selectedIndex].text;

                            $dealerSearchRange.options[$dealerSearchRange.selectedIndex].value = radiusKM;
                            $dealerSearchRange.options[$dealerSearchRange.selectedIndex].text = radiusKM + 'km';
                            this.$noBounds.value = 1;
                            this.$formSubmit.click();

                            $dealerSearchRange.options[$dealerSearchRange.selectedIndex].value = oldRange;
                            $dealerSearchRange.options[$dealerSearchRange.selectedIndex].text = oldText;
                        }, 1000);
                    }
                } else {
                    console.warn('No results found');
                }
            } else {
                console.warn('Geocoder failed due to: ' + status);
            }
        });
    }

    renewMarker (dealers) {
        this.removeAllMarkers();

        // add new Marker to the map
        if (dealers.length > 0) {
            for (let locationIndex = 0; locationIndex < dealers.length; locationIndex++) {
                this.addMarker(dealers[locationIndex]);
            }
        }
        this.setCluster(this.markerImages[2].url);

        this.checkAndSetCenter();

        if (window.innerWidth < 1024) {
            this.$dealerResult.scrollLeft = 0;
        } else {
            this.$dealerResult.scrollTop = 0;
        }
    }

    removeAllMarkers () {
        // empty Clusters
        this.markerCluster.clearMarkers();

        // remove old Marker
        if (this.mapMarker.length > 0) {
            for (let locationIndex = 0; locationIndex < this.mapMarker.length; locationIndex++) {
                this.mapMarker[locationIndex].setMap(null);
            }
        }

        // empty Array
        this.mapMarker = [];
    }

    setBounds (marker, callback) {
        if (marker.length > 0) {
            const bounds = new google.maps.LatLngBounds(); // eslint-disable-line

            for (let bounceIndex = 0; bounceIndex < marker.length; bounceIndex++) {
                bounds.extend(new google.maps.LatLng(marker[bounceIndex].lat, marker[bounceIndex].lng)); // eslint-disable-line
            }

            this.map.setCenter(bounds.getCenter());
            this.map.fitBounds(bounds);

            setTimeout(() => {
                if (this.map.getZoom() <= 5) {
                    this.map.setZoom(this.settings.resetZoom);
                    console.info('reset map zoom to ' + this.settings.resetZoom);
                }
            }, 500);

            if (typeof callback === 'function') {
                callback();
            }
        } else {
            this.checkAndSetCenter();
        }
    }
}

export { StoreFinderMap };
